import { render, staticRenderFns } from "./AuxiliarySubjectDetail.vue?vue&type=template&id=4b36d74c&scoped=true"
import script from "./AuxiliarySubjectDetail.vue?vue&type=script&lang=js"
export * from "./AuxiliarySubjectDetail.vue?vue&type=script&lang=js"
import style0 from "./AuxiliarySubjectDetail.vue?vue&type=style&index=0&id=4b36d74c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b36d74c",
  null
  
)

export default component.exports